import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CasellaConfigService, ROUTER_URLS } from '@portal/common';
import { GtmLinkClickDirective } from '@shared/gtm';

@Component({
  selector: 'csl-footer',
  standalone: true,
  imports: [RouterLink, GtmLinkClickDirective],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  private readonly configService = inject(CasellaConfigService);

  mainSiteUrl = this.configService.config.MAIN_SITE_URL;
  contactUsUrl = this.configService.config.CONTACT_US_URL;
  privacyUrl = this.configService.config.PRIVACY_URL;
  termsUrl = this.configService.config.TERMS_URL;
  residentialUrl = `./${ROUTER_URLS.residential}`;
  commercialUrl = `./${ROUTER_URLS.commercial}`;

  currentYear = new Date().getFullYear();
}
